import { render, staticRenderFns } from "./GestionSeguimiento.vue?vue&type=template&id=b975bc0a&"
import script from "./GestionSeguimiento.vue?vue&type=script&lang=js&"
export * from "./GestionSeguimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports